import supportModule from '../supportModule';

function supportService($log, httpService, urlService, resources) {
  'ngInject'; 

  return {
    getMetaData: function (url) {
        var config = {
            url: url
        };
        return httpService.httpGet(config);
    },

    submitForm: function (data, url) {
        var config = {
            url: url
        };
        return httpService.httpPost(config, data);
    },

    checkValidUsername: function (username) {
        if (typeof username === "undefined") {
            username = "";
        }
        var url = Roblox.EnvironmentUrls.authApi + resources.urls.checkUsername;

        var config = {
            url: url
        };

        var params = {
            username: username
        };
        return httpService.httpGet(config, params);
    }
  }
}

supportModule.factory('supportService', supportService);

export default supportService;